import { createStore } from 'redux';
import rootReducer from './reducer';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web and AsyncStorage for react-native

const persistConfig = {
  key: 'galilaio',
  storage,
}

const persistedReducer = persistReducer(persistConfig, rootReducer);
export default createStore(persistedReducer);